module.exports = __webpack_public_path__ + "media/images/login/alexandre-godreau-431553-unsplash-1aab74bbbd9dee9d8ee8bae5f918d899.jpg";